import type { AgentChatTurnMode } from "../api/e2e";

export const MODEL_CHAT_PARAM = "chat";
export const MODEL_CHAT_MODE_STORAGE_KEY = "fdr-e2e-agent-model-chat-mode";

export function storedModelChatMode(): AgentChatTurnMode {
  if (typeof window === "undefined") return "ask";
  try {
    const stored = window.localStorage.getItem(MODEL_CHAT_MODE_STORAGE_KEY);
    if (
      stored === "ask" ||
      stored === "edit" ||
      stored === "edit_autoapprove"
    ) {
      return stored;
    }
  } catch {
    // Chat remains usable when browser storage is unavailable.
  }
  return "ask";
}

export function storeModelChatMode(mode: AgentChatTurnMode): void {
  try {
    window.localStorage.setItem(MODEL_CHAT_MODE_STORAGE_KEY, mode);
  } catch {
    // The in-memory selection remains authoritative for this page.
  }
}

export function modelChatSidePeekOpen(params: URLSearchParams): boolean {
  return (
    params.get(MODEL_CHAT_PARAM) === "open" || params.get("tab") === "chat"
  );
}

export function modelChatSidePeekParams(
  current: URLSearchParams,
  open: boolean,
): URLSearchParams {
  const next = new URLSearchParams(current);
  if (next.get("tab") === "chat") next.delete("tab");
  if (open) next.set(MODEL_CHAT_PARAM, "open");
  else next.delete(MODEL_CHAT_PARAM);
  return next;
}
